<template>
  <div class="nps-container">
    <h3>{{ this.$rttI18n.tenantSpecificContent('headerNps') }}</h3>
    <p>
      {{ this.$rttI18n.tenantSpecificContent('bodyNps') }}
    </p>
    <hr aria-hidden="true" />
    <div :class="!isBelowLargestBreakpoint ? 'form-container' : ''">
      <div id="consent-container">
        <v-checkbox
          v-model="npsConsent"
          class="checkbox"
          color="info"
          required
          @update:model-value="toggleNpsConsent"
        >
        </v-checkbox>
        <div
          class="my-4"
          v-html="
            sanitize(
              this.$rttI18n.tenantSpecificContent('consentDeclarationNps')
            )
          "
        ></div>
      </div>
      <div id="button-container">
        <v-btn
          :block="true"
          :disabled="!npsConsent"
          class="text-body-1 my-4"
          color="info"
          data-testid="btn-customizeDeliveryPeriod"
          variant="flat"
          v-on:click="openNPS"
          >{{ this.$rttI18n.tenantSpecificContent('buttonNps') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { sendAnalytics } from '@/services/analytics.js';
import { useNpsStore } from '@/stores/nps.js';
import { useResponsiveBreakpointsStore } from '@/stores/responsiveBreakpoints.js';
import { useTrackingDataStore } from '@/stores/trackingData.js';
import { openExternalUrl } from '@/util/navigation.js';
import DOMPurify from 'dompurify';

export default {
  name: 'NPSComponent',
  computed: {
    ...mapState(useNpsStore, ['npsConsent']),
    ...mapState(useResponsiveBreakpointsStore, ['isBelowLargestBreakpoint']),
    ...mapState(useTrackingDataStore, { trackingData: 'data' })
  },
  methods: {
    sanitize: DOMPurify.sanitize,
    ...mapActions(useNpsStore, ['toggleNpsConsent']),
    openNPS() {
      sendAnalytics(this.trackingData, 'clicksStats', 'NPS');
      openExternalUrl(this.trackingData.feedback?.externalUrl);
    }
  }
};
</script>

<style scoped>
.checkbox {
  display: block;
}

div#consent-container {
  display: flex;
  text-align: left;
}

div#button-container {
  button:disabled {
    color: rgb(164 166 182) !important;
    background-color: rgb(226 226 226) !important;
  }
}

div.form-container {
  display: flex;
  gap: 2em;
  justify-content: space-between;
}

div.nps-container {
  padding-top: 1em;
  text-align: center;
}

hr {
  margin-top: 1.5em;
  margin-bottom: 0.8em;
}
</style>
